import React, { createContext, useContext } from "react";
import { TGenericFormType } from "@adgm/cross-models";

interface IGenericFormContextValue {
    /** 表单类型，用于区分不同的表单样式和行为 */
    genericFormType?: TGenericFormType;
}

const GenericFormContext = createContext<IGenericFormContextValue>({});

interface IGenericFormProviderProps extends IGenericFormContextValue {
    children: React.ReactNode;
}

export const GenericFormProvider: React.FC<IGenericFormProviderProps> = ({
    children,
    genericFormType,
}) => {
    const contextValue: IGenericFormContextValue = {
        genericFormType,
    };

    return (
        <GenericFormContext.Provider value={contextValue}>
            {children}
        </GenericFormContext.Provider>
    );
};

export const useGenericFormContext = () => {
    const context = useContext(GenericFormContext);
    if (context === undefined) {
        throw new Error("useGenericFormContext must be used within a GenericFormProvider");
    }
    return context;
};
